import api from "api/config";

export const searchOperationsAPI = async (params, signal) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/operations/search",
    params,
    signal,
  });
  return response.data;
};

/**
 * Create Template
 */
export const createOperationsTemplateAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/operations/templates",
    data: payload,
  });

  return response.data;
};

/**
 * Get Templates Dropdown
 */
export const getOperationsTemplatesAPI = async (hotelId) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/operations/templates/dropdown",
    params: { hotelId },
  });

  return response.data;
};

/**
 * Get Template By Id
 */
export const getOperationsTemplateByIdAPI = async (templateId) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/operations/templates/${templateId}`,
  });

  return response.data;
};

/**
 * Update Template
 */
export const updateOperationsTemplateAPI = async ({ templateId, data }) => {
  const response = await api({
    method: "PATCH",
    url: `/api/v1/operations/templates/${templateId}`,
    data,
  });

  return response.data;
};

/**
 * Delete Template
 */
export const deleteOperationsTemplateAPI = async ({ templateId, lastKnownUpdatedAt }) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/operations/templates/${templateId}`,
    data: { lastKnownUpdatedAt },
  });

  return response.data;
};

/**
 * Get Deleted Templates
 */
export const getDeletedOperationsTemplatesAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/operations/templates/deleted/list",
    data: payload,
  });

  return response.data;
};

/**
 * Restore Template
 */
export const restoreOperationsTemplateAPI = async (templateId) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/operations/templates/${templateId}/restore`,
  });

  return response.data;
};

/**
 * Load Entry
 */
export const getOperationsEntryAPI = async ({ hotelId, templateId, operationDate }) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/operations/entries",
    params: {
      hotelId,
      templateId,
      operationDate,
    },
  });

  return response.data;
};

/**
 * Save Entry
 */
export const saveOperationsEntryAPI = async (payload) => {
  const response = await api({
    method: "PUT",
    url: "/api/v1/operations/entries",
    data: payload,
  });

  return response.data;
};
